import util from '@bmp-vue/core/api/util'

const controller = 'AuditTrail'
export default Object.assign({}, util.GetCrud(controller, null), {
  ComboEntidades: function () {
    return util.Axios.Get(controller + '/ComboEntidades')
  }
})
